export default __webpack_public_path__ + "static/media/ic_right_caret_sm.17413f95.svg";